import api from "../../../utils/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../../rootReducer";

export const findSigners = createAsyncThunk(
  "documentShow/findSigners",
  async (document: string, { getState, rejectWithValue }) => {
    try {
      const url = new URL(`${api.baseURL}documentstakeholder`);
      url.searchParams.append(
        "where",
        JSON.stringify({
          // document: state.documentShow.document.id,
          document,
        }),
      );
      const token = localStorage.getItem("token");
      const headers = new Headers();
      headers.append("Authorization", `Bearer ${token}`);
      headers.append("Content-Type", "application/json");

      let response = await fetch(url.toJSON(), {
        method: "GET",
        headers: headers,
      });
      if (!response.ok) {
        throw response.statusText;
      }
      let data = await response.json();
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
